// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1YfsD","alert":"SettungsInbox_alert__2RjkH"};